/* eslint-disable new-cap */
import validator from 'validator';
// eslint-disable-next-line no-unused-vars
import { isEmail } from 'validator/lib/isEmail';
import AOS from '@/components/aos';
import fullpage from 'fullpage.js';

import '~/sass/pages/homepage.scss';

const { $ } = window;
// eslint-disable-next-line no-unused-vars
let fullpageInstance = null;

function loadSettimeOut() {
  setTimeout(() => {
    $('#fullpage').removeClass('loading');
  }, 10);
}

function mailValidator() {
  let resultText = null;
  const $result = $('#email-alert .result');
  const $popup = $('#popup-email-alert');
  // const $email = $('#email');
  const emailVal = $('#email').val();
  const emailValidator = validator.isEmail(emailVal);
  const btnName = $(this).attr('id');
  console.log(btnName);

  if (btnName === 'email-subscribe' && emailValidator) {
    resultText = `${emailVal} 成功送出！<br/>您已完成電子報訂閱！`;
    // $email.removeClass('is-invalid').addClass('is-valid');
    $result.html(resultText);
    $popup.trigger('click');
  } else if (btnName === 'email-unsubscribe' && emailValidator) {
    resultText = `${emailVal} 取消訂閱成功！<br/>期待您未來能持續關注TOYOTA喔！`;
    // $email.removeClass('is-invalid').addClass('is-valid');
    $result.html(resultText);
    $popup.trigger('click');
  } else {
    resultText = 'E-mail格式有誤，請重新填寫！';
    // $email.removeClass('is-valid').addClass('is-invalid');
    $result.text(resultText);
    $popup.trigger('click');
  }
}

const initFullpageInstance = () => {
  fullpageInstance = new fullpage('#fullpage', {
    licenseKey: 'D1WK9-D9LLK-K4RSH-6TKJ9-KYALL',
    // anchors: ['beyond-zero', '立即預選', '純電世代', '探索無限', 'beyond PARTNER', 'beyond SPACE', 'beyond WORLD', 'beyond SAFETY', '影音專區', 'Footer'],
    paddingTop: '72px',
    navigation: true,
    navigationPosition: 'left',
    navigationTooltips: [
      '',
      '立即預選',
      '純電世代',
      '探索無限',
      'beyond PARTNER',
      'beyond SPACE',
      'beyond WORLD',
      'beyond SAFETY',
      '影音專區',
      // 'beforeFooter',
      'Footer',
    ],
    showActiveTooltip: true,
    responsiveWidth: 769,
    scrollOverflow: true,
    afterLoad: (origin, destination) => {
      if (destination.isLast || destination.isFirst) {
        $('#fp-nav').css('opacity', '0');
      } else {
        $('#fp-nav').css('opacity', '1');
      }
      // if (destination.index === 9) {
      //   $('#fp-nav').css('opacity', '0');
      // }
    },
    onLeave: (origin, destination) => {
      if (destination.isLast || destination.isFirst) {
        $('#fp-nav').css('opacity', '0');
      } else {
        $('#fp-nav').css('opacity', '1');
      }
      // if (destination.index === 9) {
      //   $('#fp-nav').css('opacity', '0');
      // }
    },
    onScrollOverflow: (section, slide, position, direction) => {
      if (direction === 'up') {
        // eslint-disable-next-line no-undef
        fullpage_api.moveTo(9);
      }
      console.log(direction);
    },
    afterRender: () => {
      Array.prototype.forEach.call(document.querySelectorAll('#fp-nav ul li .fp-tooltip'), (t) => {
        t.addEventListener('click', (e) => {
          e.target.parentElement.querySelector('a').dispatchEvent(new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
          }));
        });
      });
    },
  });
};

const collapseTextInit = () => {
  function collapseSection1() {
    const textNode = $('#s1-more');
    const parentNode = $('.s1-parent');
    const textWrapNode = $('#s1-text-wrap');
    const textHeight = textWrapNode.css('height');
    textWrapNode.css('height', '48px');
    const arrowNode = $('.s1-more-arrow-icon');
    const moreNode = $('.s1-more');
    const lessNode = $('.s1-less');
    parentNode.css('height', '70px');
    textNode.on('click', () => {
      if (Math.ceil(textWrapNode.css('height').replace('px', '')) !== 48) {
        textWrapNode.css('height', '48px');
        parentNode.css('height', '70px');
        arrowNode.css('transform', 'rotate(180deg)');
        moreNode.css('display', 'inline-block');
        lessNode.css('display', 'none');
      } else {
        textWrapNode.css('height', `${parseInt(textHeight, 10) + 12}px`);
        const parentHeight = textHeight.replace('px', '');
        parentNode.css('height', `${parseInt(parentHeight, 10) + 25}px`);
        arrowNode.css('transform', 'rotate(0deg)');
        moreNode.css('display', 'none');
        lessNode.css('display', 'inline-block');
      }
    });
  }
  function collapseSection2() {
    const textNode = $('#s2-more');
    const parentNode = $('.s2-parent');
    const textWrapNode = $('#s2-text-wrap');
    const textHeight = textWrapNode.css('height');
    textWrapNode.css('height', '48px');
    const arrowNode = $('.s2-more-arrow-icon');
    const moreNode = $('.s2-more');
    const lessNode = $('.s2-less');
    parentNode.css('height', '70px');
    textNode.on('click', () => {
      if (Math.ceil(textWrapNode.css('height').replace('px', '')) !== 48) {
        textWrapNode.css('height', '48px');
        parentNode.css('height', '70px');
        arrowNode.css('transform', 'rotate(180deg)');
        moreNode.css('display', 'inline-block');
        lessNode.css('display', 'none');
      } else {
        textWrapNode.css('height', `${parseInt(textHeight, 10) + 12}px`);
        const parentHeight = textHeight.replace('px', '');
        parentNode.css('height', `${parseInt(parentHeight, 10) + 25}px`);
        arrowNode.css('transform', 'rotate(0deg)');
        moreNode.css('display', 'none');
        lessNode.css('display', 'inline-block');
      }
    });
  }
  function collapseSection3() {
    const textNode = $('#s3-more');
    const parentNode = $('.s3-parent');
    const textWrapNode = $('#s3-text-wrap');
    const textHeight = textWrapNode.css('height');
    textWrapNode.css('height', '48px');
    const arrowNode = $('.s3-more-arrow-icon');
    const moreNode = $('.s3-more');
    const lessNode = $('.s3-less');
    parentNode.css('height', '70px');
    textNode.on('click', () => {
      if (Math.ceil(textWrapNode.css('height').replace('px', '')) !== 48) {
        textWrapNode.css('height', '48px');
        parentNode.css('height', '70px');
        arrowNode.css('transform', 'rotate(180deg)');
        moreNode.css('display', 'inline-block');
        lessNode.css('display', 'none');
      } else {
        textWrapNode.css('height', `${parseInt(textHeight, 10) + 12}px`);
        const parentHeight = textHeight.replace('px', '');
        parentNode.css('height', `${parseInt(parentHeight, 10) + 25}px`);
        arrowNode.css('transform', 'rotate(0deg)');
        moreNode.css('display', 'none');
        lessNode.css('display', 'inline-block');
      }
    });
  }
  function collapseSection4() {
    const textNode = $('#s4-more');
    const parentNode = $('.s4-parent');
    const textWrapNode = $('#s4-text-wrap');
    const textHeight = textWrapNode.css('height');
    textWrapNode.css('height', '48px');
    const arrowNode = $('.s4-more-arrow-icon');
    const moreNode = $('.s4-more');
    const lessNode = $('.s4-less');
    parentNode.css('height', '70px');
    textNode.on('click', () => {
      if (Math.ceil(textWrapNode.css('height').replace('px', '')) !== 48) {
        textWrapNode.css('height', '48px');
        parentNode.css('height', '70px');
        arrowNode.css('transform', 'rotate(180deg)');
        moreNode.css('display', 'inline-block');
        lessNode.css('display', 'none');
      } else {
        textWrapNode.css('height', `${parseInt(textHeight, 10) + 12}px`);
        const parentHeight = textHeight.replace('px', '');
        parentNode.css('height', `${parseInt(parentHeight, 10) + 25}px`);
        arrowNode.css('transform', 'rotate(0deg)');
        moreNode.css('display', 'none');
        lessNode.css('display', 'inline-block');
      }
    });
  }
  function collapseSection5() {
    const textNode = $('#s5-more');
    const parentNode = $('.s5-parent');
    const textWrapNode = $('#s5-text-wrap');
    const textHeight = textWrapNode.css('height');
    textWrapNode.css('height', '48px');
    const arrowNode = $('.s5-more-arrow-icon');
    const moreNode = $('.s5-more');
    const lessNode = $('.s5-less');
    parentNode.css('height', '70px');
    textNode.on('click', () => {
      if (Math.ceil(textWrapNode.css('height').replace('px', '')) !== 48) {
        textWrapNode.css('height', '48px');
        parentNode.css('height', '70px');
        arrowNode.css('transform', 'rotate(180deg)');
        moreNode.css('display', 'inline-block');
        lessNode.css('display', 'none');
      } else {
        textWrapNode.css('height', `${parseInt(textHeight, 10) + 12}px`);
        const parentHeight = textHeight.replace('px', '');
        parentNode.css('height', `${parseInt(parentHeight, 10) + 25}px`);
        arrowNode.css('transform', 'rotate(0deg)');
        moreNode.css('display', 'none');
        lessNode.css('display', 'inline-block');
      }
    });
  }
  function collapseSection6() {
    const textNode = $('#s6-more');
    const parentNode = $('.s6-parent');
    const textWrapNode = $('#s6-text-wrap');
    const textHeight = textWrapNode.css('height');
    textWrapNode.css('height', '48px');
    const arrowNode = $('.s6-more-arrow-icon');
    const moreNode = $('.s6-more');
    const lessNode = $('.s6-less');
    parentNode.css('height', '70px');
    textNode.on('click', () => {
      if (Math.ceil(textWrapNode.css('height').replace('px', '')) !== 48) {
        textWrapNode.css('height', '48px');
        parentNode.css('height', '70px');
        arrowNode.css('transform', 'rotate(180deg)');
        moreNode.css('display', 'inline-block');
        lessNode.css('display', 'none');
      } else {
        textWrapNode.css('height', `${parseInt(textHeight, 10) + 12}px`);
        const parentHeight = textHeight.replace('px', '');
        parentNode.css('height', `${parseInt(parentHeight, 10) + 25}px`);
        arrowNode.css('transform', 'rotate(0deg)');
        moreNode.css('display', 'none');
        lessNode.css('display', 'inline-block');
      }
    });
  }
  collapseSection1();
  collapseSection2();
  collapseSection3();
  collapseSection4();
  collapseSection5();
  collapseSection6();
};

function countKM() {
  $('#count').prop('Counter', 0).animate(
    {
      Counter: $('#count').text(),
    },
    {
      duration: 3000,
      easing: 'linear',
      step: (now) => {
        $('#count').text(Math.ceil(now));
      },
    },
  );
}

$(document).ready(() => {
  $('.main-wrapper').css('padding-top', '0px');
  console.log('index init');
  $('#email-subscribe').on('click', mailValidator); // 訂閱
  $('#email-unsubscribe').on('click', mailValidator); // 取消訂閱

  AOS.refresh();

  initFullpageInstance();
  collapseTextInit();
  countKM();

  loadSettimeOut();

  // $('.video-section').scroll(() => {
  //   window.scrollTo({ top: window.innerHeight });
  // });
  $('.item1').on('click', () => {
    $('iframe')[0].setAttribute('src', 'https://www.youtube.com/embed/nGEQVl9iYdo');
    $('.video-mask1').css('display', 'flex');
  });
  $('.video1-close').on('click', () => {
    $('iframe')[0].setAttribute('src', '');
    $('.video-mask1').css('display', 'none');
  });
  $('.item2').on('click', () => {
    $('iframe')[1].setAttribute('src', 'https://www.youtube.com/embed/whwteScnDYA');
    $('.video-mask2').css('display', 'flex');
  });
  $('.video2-close').on('click', () => {
    $('iframe')[1].setAttribute('src', '');
    $('.video-mask2').css('display', 'none');
  });
  $('.item3').on('click', () => {
    $('iframe')[2].setAttribute('src', 'https://www.youtube.com/embed/E6-DmlCObfE');
    $('.video-mask3').css('display', 'flex');
  });
  $('.video3-close').on('click', () => {
    $('iframe')[2].setAttribute('src', '');
    $('.video-mask3').css('display', 'none');
  });
  $('.item4').on('click', () => {
    $('iframe')[3].setAttribute('src', 'https://www.youtube.com/embed/qnrrNtUV2Oc');
    $('.video-mask4').css('display', 'flex');
  });
  $('.video4-close').on('click', () => {
    $('iframe')[3].setAttribute('src', '');
    $('.video-mask4').css('display', 'none');
  });
  $('.item5').on('click', () => {
    $('iframe')[4].setAttribute('src', 'https://www.youtube.com/embed/05Q4Lw5vrhg');
    $('.video-mask5').css('display', 'flex');
  });
  $('.video5-close').on('click', () => {
    $('iframe')[4].setAttribute('src', '');
    $('.video-mask5').css('display', 'none');
  });
  $('.item6').on('click', () => {
    $('iframe')[5].setAttribute('src', 'https://www.youtube.com/embed/laspsEukW3M');
    $('.video-mask6').css('display', 'flex');
  });
  $('.video6-close').on('click', () => {
    $('iframe')[5].setAttribute('src', '');
    $('.video-mask6').css('display', 'none');
  });
  $('.item7').on('click', () => {
    $('iframe')[6].setAttribute('src', 'https://www.youtube.com/embed/iRXWxbtx9PQ');
    $('.video-mask7').css('display', 'flex');
  });
  $('.video7-close').on('click', () => {
    $('iframe')[6].setAttribute('src', '');
    $('.video-mask7').css('display', 'none');
  });
});
